
define('eteration/widgets/ui-i18n',[
        'knockout',
        'eteration/widgets/widget-util',
        'eteration/eteration-i18n',
        'jquery.placeholder'
        ], function(ko,widgetUtil,i18n){
	
	widgetUtil.setupStringBasedTemplate(ko);
	
	ko.virtualElements.allowedBindings['i18n-html']  = true;
	ko.virtualElements.allowedBindings['i18n-text']  = true;
	ko.virtualElements.allowedBindings['i18n-attr']  = true;
	ko.virtualElements.allowedBindings['i18n-placeholder']  = true;
	ko.virtualElements.allowedBindings['i18n-data-title']  = true;
	ko.virtualElements.allowedBindings['i18n-binding']  = true;
	ko.virtualElements.allowedBindings['i18n-textWithCountry']  = true;
	ko.virtualElements.allowedBindings['i18n-textWithOptionalField']  = true;
	ko.virtualElements.allowedBindings['i18n-textWithDefault']  = true;


	var processI18n = function(element,valueAccessor) {
		 var key = ko.utils.unwrapObservable(valueAccessor()).key || {}; 
	     key = ko.utils.unwrapObservable(key);   
	    
	     var args = ko.utils.unwrapObservable(valueAccessor()).args; 
	     
	     var locale = ko.utils.unwrapObservable(valueAccessor()).locale || i18n.getUserLocale();
	     var defaultVal = ko.utils.unwrapObservable(valueAccessor()).defaultVal;
	     locale = ko.utils.unwrapObservable(locale);   
	     
	     var val = i18n.get(key, locale, args, defaultVal);
	  
    	 return val;

	};
	
	// if it is available , show the country specific content  //	
	ko.bindingHandlers['i18n-textWithCountry'] = {

		init: function (element, valueAccessor, allBindingsAccessor) {
			ko.bindingHandlers['i18n-textWithCountry'].process(element, valueAccessor);
	    },
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			ko.bindingHandlers['i18n-textWithCountry'].process(element, valueAccessor);
		},
		process :function(element,valueAccessor) {
			var key = ko.unwrap(valueAccessor().key)
			var locale = ko.unwrap(valueAccessor().locale || i18n.getUserLocale())
			var args = ko.unwrap(valueAccessor().args)
			var val = i18n.getWithCountry(key, locale, args);
			val && $(element).html(val); 
		}
	};
	
	ko.bindingHandlers['i18n-textWithOptionalField'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				ko.bindingHandlers['i18n-textWithOptionalField'].process(element, valueAccessor);
		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				ko.bindingHandlers['i18n-textWithOptionalField'].process(element, valueAccessor);
			},
			process :function(element,valueAccessor) {
				var key = ko.unwrap(valueAccessor().key)
				var locale = ko.unwrap(valueAccessor().locale || i18n.getUserLocale())
				var args = ko.unwrap(valueAccessor().args)
				var val = i18n.getWithOptionalField(key, locale, args,valueAccessor().optionalField );
				val && $(element).html(val); 
			}
		};
	
	ko.bindingHandlers['i18n-textWithDefault'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				ko.bindingHandlers['i18n-textWithDefault'].process(element, valueAccessor);
		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				ko.bindingHandlers['i18n-textWithDefault'].process(element, valueAccessor);
			},
			process :function(element,valueAccessor) {
				
				var key = ko.unwrap(valueAccessor().key)
				var defaultVal = ko.unwrap(valueAccessor().defaultVal)
				var val = i18n.getWithDefault(key, defaultVal)
				val && $(element).html(val); 
			}
		};
	
	
	
	ko.bindingHandlers['i18n-html'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				ko.bindingHandlers['i18n-html'].process(element, valueAccessor);
		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				ko.bindingHandlers['i18n-html'].process(element, valueAccessor);
			},
			process :function(element,valueAccessor) {
		    	 
		    	 var val = processI18n(element,valueAccessor);
				 val && $(element).html(val); 
			}
		};
		
		
	ko.bindingHandlers['i18n-text'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {

				ko.bindingHandlers['i18n-text'].process(element, valueAccessor);

		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				
				ko.bindingHandlers['i18n-text'].process(element, valueAccessor);
	
			},
			process: function(element,valueAccessor) {
				var val = processI18n(element,valueAccessor);
				val && $(element).html(val); 
			}
		};
		
	ko.bindingHandlers['i18n-data-title'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {

				ko.bindingHandlers['i18n-data-title'].process(element, valueAccessor);

		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				
				ko.bindingHandlers['i18n-data-title'].process(element, valueAccessor);
	
			},
			process: function(element,valueAccessor) {
				var val = processI18n(element,valueAccessor);
		    	 $(element).attr('data-title',val);
			}
		};
		
	
	
	ko.bindingHandlers['i18n-placeholder'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				$(element).placeholder();
				ko.bindingHandlers['i18n-placeholder'].process(element, valueAccessor);
				
		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				$(element).placeholder();
				ko.bindingHandlers['i18n-placeholder'].process(element, valueAccessor);
				
			},
			process : function(element,valueAccessor) {
				var val = processI18n(element,valueAccessor);
                $(element).attr("placeholder",val);
			}
	};    
	
	
	ko.bindingHandlers['i18n-attrs'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				 
				ko.bindingHandlers['i18n-attrs'].process(element,valueAccessor);

		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				ko.bindingHandlers['i18n-attrs'].process(element,valueAccessor);
			},
			process : function(element,valueAccessor) {
				 var values = ko.utils.unwrapObservable(valueAccessor());
				 
				 for (var i = 0; i < values.length; i++) {
					 var va = values[i];
					 var key = va.key || {}; 
				     key = ko.utils.unwrapObservable(key);   
				     var attr = va.attr;
				     attr = ko.utils.unwrapObservable(attr);   

				     var locale = va.locale || i18n.getUserLocale(); 
				     locale = ko.utils.unwrapObservable(locale);   
					 
			    	 $(element).attr(attr,i18n.get(key,locale));

				}
				
		    	 
		    	 
			}
	};   
	
	ko.bindingHandlers['i18n-attr'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				 
				ko.bindingHandlers['i18n-attr'].process(element,valueAccessor);

		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				ko.bindingHandlers['i18n-attr'].process(element,valueAccessor);
			},
			process : function(element,valueAccessor) {
				var parameters = ko.utils.unwrapObservable(valueAccessor());
				var val = processI18n(element,valueAccessor);
				 
		    	 $(element).attr(parameters.attr,val);

			}
	};    
	
	ko.bindingHandlers['i18n-binding'] = {

			init: function (element, valueAccessor, allBindingsAccessor) {
				ko.bindingHandlers['i18n-binding'].process(element, valueAccessor);
		    },
			update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
				ko.bindingHandlers['i18n-binding'].process(element, valueAccessor);
			},
			process :function(element,valueAccessor) {
		    	 
		    	 var val = processI18n(element,valueAccessor);
		    	 val && $(element).html(val); 

		    	 var bindingEvent = ko.utils.unwrapObservable(valueAccessor()).bindingEvent;
		    	 var bindingElmId = ko.utils.unwrapObservable(valueAccessor()).bindingElmId;
		    	 var fn = ko.utils.unwrapObservable(valueAccessor()).fn;
		    	 
		    	 var link = null;
		    	 if(bindingElmId) {
		    		 link = $(element).find('#'+bindingElmId.id);
		    	 }
		    	 
		    	 if(link != null) {
		    		 $(link).unbind(bindingEvent.event);
		    		 $(link).bind(bindingEvent.event, function(){
		    			 fn.fn.call();
		    		 });
		    	 } else {
		    		 $(element).unbind(bindingEvent.event);
		    		 $(element).bind(bindingEvent.event, function(){
		    			 fn.fn.call();
		    		 });
		    	 }
			}
		};
});